import { Component, Input } from '@angular/core';

@Component({
  selector: 'fgb-account-panel',
  templateUrl: './account-panel.component.html',
  styleUrls: ['./account-panel.component.scss'],
})
export class AccountPanelComponent {
  @Input() titleKey: string;
  @Input() titleDefault: string;
}
